import { lightComponentColors } from "./componentColors";

const sunsetCanvas =
  "linear-gradient(348deg, transparent 0%, transparent 76%, rgba(255,185,145,0.20) 76%, rgba(255,185,145,0.20) 93%, transparent 93%, transparent 100%), linear-gradient(150deg, transparent 0%, transparent 10%, rgba(255,107,74,0.10) 10%, rgba(255,107,74,0.10) 74%, transparent 74%, transparent 100%), linear-gradient(68deg, transparent 0%, transparent 36%, rgba(194,65,90,0.05) 36%, rgba(194,65,90,0.05) 47%, transparent 47%, transparent 100%), linear-gradient(199deg, transparent 0%, transparent 37%, rgba(255,185,145,0.15) 37%, rgba(255,185,145,0.15) 47%, transparent 47%, transparent 100%), linear-gradient(180deg, #fff8f0 0%, #fef1e3 58%, #fce4cf 100%)";

const sunsetSurface =
  "linear-gradient(200deg, rgba(255,255,255,0.44) 0%, rgba(255,255,255,0.44) 23%, rgba(255,185,145,0.12) 23%, rgba(255,185,145,0.12) 48%, rgba(255,107,74,0.06) 48%, rgba(255,107,74,0.06) 61%, rgba(255,255,255,0.30) 61%, rgba(255,255,255,0.30) 100%), linear-gradient(126deg, rgba(255,221,191,0.18) 0%, rgba(255,221,191,0.18) 33%, rgba(255,255,255,0.24) 33%, rgba(255,255,255,0.24) 68%, rgba(194,65,90,0.04) 68%, rgba(194,65,90,0.04) 100%), linear-gradient(145deg, #fffaf5 0%, #fce4cf 100%)";

const sunsetSelectedSurface =
  "linear-gradient(200deg, rgba(255,255,255,0.42) 0%, rgba(255,255,255,0.42) 23%, rgba(255,151,111,0.16) 23%, rgba(255,151,111,0.16) 48%, rgba(194,65,90,0.07) 48%, rgba(194,65,90,0.07) 61%, rgba(255,255,255,0.26) 61%, rgba(255,255,255,0.26) 100%), linear-gradient(135deg, #fff1df 0%, #ffd8c2 100%)";

const sunsetPanelSurface =
  "linear-gradient(216deg, rgba(123,63,55,0.05) 0%, rgba(123,63,55,0.05) 25%, rgba(74,32,41,0.05) 25%, rgba(74,32,41,0.05) 38%, rgba(255,177,132,0.05) 38%, rgba(255,177,132,0.05) 75%, rgba(87,37,48,0.05) 75%, rgba(87,37,48,0.05) 100%), linear-gradient(44deg, rgba(170,79,63,0.05) 0%, rgba(170,79,63,0.05) 34%, rgba(225,126,94,0.05) 34%, rgba(225,126,94,0.05) 57%, rgba(54,26,40,0.05) 57%, rgba(54,26,40,0.05) 89%, rgba(146,61,73,0.05) 89%, rgba(146,61,73,0.05) 100%), linear-gradient(241deg, rgba(98,42,48,0.05) 0%, rgba(98,42,48,0.05) 14%, rgba(221,98,74,0.05) 14%, rgba(221,98,74,0.05) 60%, rgba(255,180,130,0.05) 60%, rgba(255,180,130,0.05) 69%, rgba(166,67,76,0.05) 69%, rgba(166,67,76,0.05) 100%), linear-gradient(249deg, rgba(255,202,158,0.05) 0%, rgba(255,202,158,0.05) 32%, rgba(137,54,68,0.05) 32%, rgba(137,54,68,0.05) 35%, rgba(222,112,82,0.05) 35%, rgba(222,112,82,0.05) 51%, rgba(185,76,75,0.05) 51%, rgba(185,76,75,0.05) 100%), linear-gradient(92deg, #f4d8c4, #f4d8c4)";

export const lemmonSunset = {
  lemmonSunset: {
    "color-scheme": "light",
    primary: "#4169e1",
    "primary-content": "#fff",

    secondary: "#2d2a3a",
    "secondary-content": "#fff",

    accent: "#8D4514",
    "accent-content": "#fff",

    neutral: "#8a8398",
    "neutral-content": "#fff",

    "base-100": "#fff8f0",
    "base-200": "#fef1e3",
    "base-300": "#fce4cf",
    "base-content": "#222",
    "--font-family": "'Open Sans', sans-serif",
    "--body-bg-color": sunsetCanvas,
    "--form-control-background":
      "linear-gradient(135deg, rgba(255,255,255,0.62) 0%, rgba(255,255,255,0.18) 100%), linear-gradient(135deg, #fff8f0 0%, #fce4cf 100%)",
    "--lemmon-switcher-background": "rgba(45, 42, 58, 0.06)",
    "--lemmon-switcher-border": "rgba(138, 93, 64, 0.16)",
    "--lemmon-switcher-indicator-background": "rgba(255, 255, 255, 0.72)",
    "--lemmon-switcher-indicator-overlay-background":
      "rgba(255, 107, 74, 0.10)",
    "--lemmon-switcher-indicator-shadow": "rgba(91, 55, 34, 0.16) 0px 1px 3px",

    info: "#0ea5e9",
    "info-content": "#001824",
    success: "#16a34a",
    "success-content": "#ffffff",
    warning: "#b45309",
    "warning-content": "#ffffff",
    error: "#e11d48",
    "error-content": "#ffffff",

    "--pos-card-bg": sunsetSurface,
    "--pos-card-selected-bg": sunsetSelectedSurface,
    "--pos-bar-color": "#2d2a3a",
    "--pos-panel-bg": sunsetPanelSurface,
    "--pos-border-color": "rgba(194,65,90,0.15)",
    "--pos-shadow-color": "rgba(123,63,55,0.16)",
    "--pos-shadow-highlight": "rgba(255,255,255,0.72)",
    ...lightComponentColors,
    "--floor-plan-background": sunsetCanvas,
    "--floor-plan-grid-line": "rgba(45,42,58,0.14)",
    "--floor-plan-grid-padding": "rgba(255,107,74,0.05)",
    "--floor-plan-section-divider": "rgba(194,65,90,0.16)",
    "--floor-plan-fixture-background": sunsetSelectedSurface,
    "--floor-plan-fixture-content": "#4a3140",
    "--floor-plan-fixture-shadow":
      "0 2px 8px rgba(123,63,55,0.14), inset 0 1px 0 rgba(255,255,255,0.78)",
    "--floor-plan-selection-background": "rgba(255,107,74,0.20)",
    "--floor-plan-selection-border": "#ff6b4a",
    // Pale gingham keeps free tables in the same cloth family as busy tables.
    "--floor-plan-table-free-background":
      "repeating-linear-gradient(0deg, rgba(194,65,90,0.11) 0 9px, transparent 9px 18px), repeating-linear-gradient(90deg, rgba(194,65,90,0.11) 0 9px, transparent 9px 18px), linear-gradient(145deg, #fff6eb 0%, #fce4cf 55%, #f5cfb8 100%)",
    "--floor-plan-table-free-content": "#4a2632",
    "--floor-plan-table-free-shadow":
      "0 2px 8px rgba(123,63,55,0.16), inset 0 1px 0 rgba(255,255,255,0.72)",
    // Busy-table cloth options. Keep exactly one property uncommented.
    // Classic red-and-white gingham (active; previously used by Black).
    "--floor-plan-table-busy-background":
      "repeating-linear-gradient(0deg, rgba(255,255,255,0.18) 0 9px, transparent 9px 18px), repeating-linear-gradient(90deg, rgba(255,255,255,0.18) 0 9px, transparent 9px 18px), linear-gradient(145deg, #b91c1c 0%, #991b1b 52%, #7f1d1d 100%)",
    // Burgundy bistro check.
    // "--floor-plan-table-busy-background":
    //   "repeating-linear-gradient(0deg, transparent 0 13px, rgba(255,236,214,0.16) 13px 16px), repeating-linear-gradient(90deg, transparent 0 13px, rgba(255,236,214,0.16) 13px 16px), linear-gradient(145deg, #881337 0%, #6b102d 55%, #4c0519 100%)",
    // Forest-green restaurant cloth with a fine woven pinstripe.
    // "--floor-plan-table-busy-background":
    //   "repeating-linear-gradient(0deg, transparent 0 7px, rgba(236,253,245,0.07) 7px 8px), repeating-linear-gradient(90deg, transparent 0 7px, rgba(236,253,245,0.07) 7px 8px), linear-gradient(145deg, #166534 0%, #14532d 52%, #052e16 100%)",
    // Navy-and-white café check.
    // "--floor-plan-table-busy-background":
    //   "repeating-linear-gradient(0deg, rgba(239,246,255,0.16) 0 8px, transparent 8px 16px), repeating-linear-gradient(90deg, rgba(239,246,255,0.16) 0 8px, transparent 8px 16px), linear-gradient(145deg, #1d4ed8 0%, #1e3a8a 55%, #172554 100%)",
    "--floor-plan-table-busy-shadow":
      "0 3px 10px rgba(194,65,90,0.28), inset 0 1px 0 rgba(255,255,255,0.24)",
    "--order-card-background": sunsetSurface,
    "--order-filter-header-background": "var(--order-card-background)",
    "--order-filter-control-background":
      "linear-gradient(135deg, rgba(255,255,255,0.70), rgba(254,241,227,0.86))",
    "--order-card-border": "rgba(163,86,72,0.28)",
    "--order-card-section-border": "rgba(123,63,55,0.14)",
    "--order-card-muted-content": "#76636b",
    "--order-card-dine-in-background": "#665d75",
    "--order-card-takeaway-background": sunsetSelectedSurface,
    "--order-card-takeaway-content": "#422006",
    "--floor-plan-walker-accent": "#d97706",
    "--floor-plan-walker-accent-alt": "#c2417a",
  },
};
